import Link from 'app/components/router/Link';
import { getCategoryRoute } from 'app/models/route/selectors/materials';
import { AppState } from 'app/store';
import { EntityStringId } from 'app/types/entity';
import { connect } from 'react-redux';

interface IProps {
  categoryId: EntityStringId;
  courseId?: EntityStringId;
}

const CategoryLink = connect(
  (state: AppState, { categoryId, courseId }: IProps) => {
    return {
      to: getCategoryRoute(state, { categoryId, courseId }),
    };
  },
  {},
  (stateProps, dispatchProps, { categoryId, courseId, ...ownProps }) => ({
    ...ownProps,
    ...dispatchProps,
    ...stateProps,
  }),
)(Link);

export default CategoryLink;
